import React from 'react';
import { motion } from 'framer-motion';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Cell, LabelList } from 'recharts';
interface ConversionCliffSlideProps {
  content: {
    headline: string;
    boldText: string;
    text: string;
    source: string;
    data: Array<{
      time: string;
      conversion: number;
    }>;
  };
}
export function ConversionCliffSlide({
  content
}: ConversionCliffSlideProps) {
  return <div className="bg-[#1C1C1C] rounded-2xl p-12 min-h-[600px] flex flex-col relative" data-id="element-113">
      <motion.h2 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl font-bold text-[#F5F5F5] mb-8 text-center" data-id="element-114">
        {content.headline}
      </motion.h2>

      <div className="flex-1 flex flex-col gap-8" data-id="element-115">
        {/* Chart Area */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="h-[300px] w-full bg-[#F5F5F5]/5 p-6 rounded-xl" data-id="element-116">
          <ResponsiveContainer width="100%" height="100%" data-id="element-117">
            <BarChart data={content.data} margin={{
            top: 20,
            right: 30,
            left: 0,
            bottom: 0
          }} data-id="element-118">
              <CartesianGrid strokeDasharray="3 3" stroke="#4D4D4D" vertical={false} data-id="element-119" />
              <XAxis dataKey="time" stroke="#F5F5F5" tick={{
              fill: '#F5F5F5'
            }} data-id="element-120" />
              <YAxis stroke="#F5F5F5" tick={{
              fill: '#F5F5F5'
            }} tickFormatter={val => `${val}%`} data-id="element-121" />
              <Bar dataKey="conversion" radius={[4, 4, 0, 0]} data-id="element-122">
                {content.data.map((entry, index) => <Cell key={`cell-${index}`} fill={index === 0 ? '#0FB07D' : '#ef4444'} data-id="element-123" />)}
                <LabelList dataKey="conversion" position="top" fill="#F5F5F5" formatter={(val: number) => `${val}%`} data-id="element-124" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </motion.div>

        {/* Text Area */}
        <div className="flex gap-8 items-center" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="w-1/2 bg-red-500/10 border border-red-500/30 p-6 rounded-xl" data-id="element-126">
            <p className="text-2xl font-bold text-red-400 leading-tight" data-id="element-127">
              {content.boldText}
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="w-1/2 text-xl text-[#F5F5F5]/80 leading-relaxed" data-id="element-128">
            {content.text}
          </motion.p>
        </div>
      </div>

      <div className="absolute bottom-6 right-8 text-sm text-[#4D4D4D] font-medium" data-id="element-129">
        {content.source}
      </div>
    </div>;
}
export default ConversionCliffSlide;